import api from './api';

export const createInvitation      = (data)         => api.post('/api/invitations', data);
export const bulkInvite            = (data)         => api.post('/api/invitations/bulk', data);
export const listInvitations       = (params)       => api.get('/api/invitations', { params });
export const revokeInvitation      = (id)           => api.delete(`/api/invitations/${id}`);
export const resendInvitation      = (id)           => api.post(`/api/invitations/${id}/resend`);
export const updateInvitationEmail = (id, email)    => api.patch(`/api/invitations/${id}/email`, { email });
export const verifyInvitation      = (token)        => api.get(`/api/invitations/verify/${token}`);
export const acceptInvitation      = (token, data)  => api.post(`/api/invitations/${token}/accept`, data);
